<script>import { fade } from "svelte/transition";
import { portal as portalAction } from "../actions/portal.js";
import { cls } from "../utils/styles.js";
import { getComponentClasses } from "./theme.js";
export let blur = false;
export let portal = false;
let className = void 0;
export { className as class };
export let fadeParams = { duration: 300 };
const settingsClasses = getComponentClasses("Backdrop");
</script>

<div
  class={cls(
    'Backdrop',
    'fixed top-0 bottom-0 left-0 right-0 flex items-center justify-center bg-surface-content/50 dark:bg-surface-300/70',
    blur && 'backdrop-blur-sm',
    settingsClasses.root,
    className
  )}
  on:keydown
  on:keyup
  on:keypress
  on:click
  on:mousedown
  on:mouseup
  in:fade|global={fadeParams}
  out:fade={fadeParams}
  use:portalAction={portal}
  role="none"
>
  <slot />
</div>
